import React from 'react';
import { dateOptionStyle } from '@fabric-ui/components';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';

export const ShortVal: React.FC<{ value?: number; unit?: string }> = ({ value, unit }) =>
  value &&
  unit && (
    <Box sx={{ ...dateOptionStyle, ...flex.center, gap: 1 }}>
      <span
        className="interval-shortval"
        style={{
          backgroundColor: 'var(--color-surface-interactive-modifier-default)',
          color: 'var(--color-content-base-secondary)',
          minWidth: '56px',
        }}>
        {value}
        {unit[0]}
      </span>
    </Box>
  );
